import { DocumentStatus, documentTitles, DocumentTypes } from 'types';

import FormSection from '../Forms/FormSection';
import { ContractDocumentSectionDescription } from '../InstallMilestonePackage/InstallationFormSectionDescriptions';

import { DocumentList } from './Documents/DocumentList';

interface ContractDocumentSectionProps {
  showSeparatorBorder?: boolean;
}

export const ContractDocumentSection = ({ showSeparatorBorder }: ContractDocumentSectionProps) => {
  return (
    <FormSection
      title="Customer Contract"
      description={ContractDocumentSectionDescription()}
      className={!showSeparatorBorder ? 'border-out' : ''}
    >
      <DocumentList
        documentTypeFilter={[]}
        additionalDocumentsToFetch={[{ types: [DocumentTypes.contract], status: [DocumentStatus.approved] }]}
        title="Contract"
        showTypeLabelOnItems={false}
        baseCategory={documentTitles.contract}
        showUploadButton={false}
        allowArchive={false}
      />
    </FormSection>
  );
};
